var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/utilFetch.ts
import UtilProgress from "@dia-ui/util_progress";
var UtilFetch = class {
  /**
   * create
   * @param url
   * @param config
   * @param processIdentifier
   */
  static create(_0) {
    return __async(this, arguments, function* (url, config = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      redirect: "follow",
      referrerPolicy: "no-referrer",
      progress: true,
      headers: {
        "Content-Type": "application/json"
      }
    }, processIdentifier = "dia-fetch") {
      if (config && config.progress) {
        UtilProgress.preFetchProgress(processIdentifier);
      }
      try {
        const _response = yield fetch(url, config);
        if (!_response.ok) {
          throw new Error(url + " | " + _response.status + " " + _response.statusText);
        }
        let response = config.progress ? UtilProgress.fetchProgress(processIdentifier, _response) : _response, json = response.headers && !response.headers.has("Content-Type") || response.headers && response.headers.has("Content-Type") && response.headers.get("Content-Type").indexOf("json") !== -1 ? yield response.json() : yield response.text();
        return new Promise((resolve, reject) => {
          try {
            resolve(json);
          } catch (_error) {
            reject(_error);
          }
        });
      } catch (error) {
        if (!(error instanceof Error)) {
          error = new Error(error);
        }
        if (typeof window !== "undefined") {
          window.dispatchEvent(new CustomEvent(processIdentifier + ":fetch:error", {
            detail: {
              error: error.toString(),
              url
            }
          }));
        }
        throw error;
      }
    });
  }
};

// src/index.ts
var src_default = UtilFetch;
export {
  src_default as default
};
